import { use_dispatch } from '@/hooks/_base/use_dispatch';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { useTranslation } from 'react-i18next';
import { ESettingsWorkspaceTab } from '../../ESettingsWorkspaceTab';

export function ViewAvailableSeats() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const dispatch = use_dispatch();

  function onClick() {
    dispatch(
      LOCAL__ui_set_string({
        key: 'page_settings_workspace_current_tab',
        value: ESettingsWorkspaceTab.SUBSCRIPTION,
        valid_values: Object.values(ESettingsWorkspaceTab),
      }),
    );
  }

  return (
    <div className="flex flex-col gap-2.5">
      <div className="text-xl">{t(i18n_page_settings_workspace.tabs.users.shared.available_seats_component.title)}</div>
      <div>{t(i18n_page_settings_workspace.tabs.users.shared.available_seats_component.description1)}</div>

      <span>
        {t(i18n_page_settings_workspace.tabs.users.shared.available_seats_component.description2)}{' '}
        <span onClick={onClick} className="underline cursor-pointer">
          {t(i18n_page_settings_workspace.tabs.users.shared.available_seats_component.button.upgrade_subscription.title)}
        </span>
      </span>
    </div>
  );
}
